export default "__VITE_ASSET__833d7180__"